var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDeleted)?_c('CBadge',{staticClass:"deleted-record-badge",attrs:{"color":"danger"}},[_vm._v(_vm._s(_vm.$t('product.deleted')))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }